var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassMenu",
    {
      attrs: {
        placement: "top",
        trigger: "click",
        "custom-class": "custom-menu-container-textalign",
        disabled: _vm.disabled
      }
    },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.$t.__(_vm.getExtensionOption(_vm.option).label),
            placement: "top",
            delay: { show: 0, hide: 1 },
            disabled: _vm.disabled
          }
        },
        [
          _c("CompassIconButton", {
            attrs: {
              icon: _vm.getExtensionOption(_vm.option).icon,
              size: "small",
              disabled: _vm.disabled,
              active: _vm.activeStyle(_vm.option),
              "show-dropdown": ""
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "dropdown" },
        _vm._l(_vm.allTextAlign, function(textAlign, indexTextAlign) {
          return _c(
            "CompassTooltip",
            {
              key: indexTextAlign,
              attrs: {
                placement: "right",
                delay: { show: 0, hide: 1 },
                disabled: _vm.disabled
              }
            },
            [
              _c("template", { slot: "content" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t.__(_vm.getExtensionOption(textAlign).label))
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "option-shortcuts" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.getExtensionOption(textAlign).shortcuts) +
                      "\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("CompassIconButton", {
                attrs: {
                  icon: _vm.getExtensionOption(textAlign).icon,
                  size: "small",
                  disabled: _vm.disabled
                },
                on: {
                  click: function($event) {
                    _vm.getExtensionOption(textAlign).action()
                  }
                }
              })
            ],
            2
          )
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }